export default function NoRecordIcon() {
  return (
    <>
      <svg
        version="1.1"
        width="80"
        height="80"
        x="0"
        y="0"
        viewBox="0 0 66 66"
        className="hovered-paths"
      >
        <g>
          <path
            fill="#e7e7e7"
            d="M48.46 5.97v50.06H12.04v3.98h40.4V5.97z"
            opacity="1"
            data-original="#b9d7ff"
            className=""
          ></path>
          <path
            fill="#ffffff"
            d="M18.33 2.04 8.11 12.26v43.82h40.4V2.04z"
            opacity="1"
            data-original="#ffffff"
            className="hovered-path"
          ></path>
          <circle
            cx="31.39"
            cy="37.41"
            r="14.47"
            fill="#e7e7e7"
            opacity="1"
            data-original="#b9d7ff"
            className=""
          ></circle>
          <path
            fill="#ebebeb"
            d="M38.7 44.73c-4.03 4.03-10.59 4.03-14.62 0s-4.03-10.59 0-14.62 10.59-4.03 14.62 0c4.04 4.02 4.04 10.58 0 14.62z"
            opacity="1"
            data-original="#ddebfd"
            className=""
          ></path>
          <path
            fill="#bebebe"
            d="m44.8 48.41-2.05-2.05c-.35.44-.72.87-1.13 1.28s-.84.78-1.28 1.13l2.05 2.05c-.23 1.04.05 2.16.85 2.97l9.23 9.23c1.25 1.25 3.28 1.25 4.53 0s1.25-3.28 0-4.53l-9.23-9.23c-.81-.8-1.93-1.08-2.97-.85zM18.28 12.21V1.99L8.06 12.21z"
            opacity="1"
            data-original="#7cb7ff"
            className=""
          ></path>
          <g fill="#1576ed">
            <path
              d="M39.22 29.57c-2.09-2.09-4.88-3.25-7.85-3.25s-5.76 1.15-7.85 3.25-3.25 4.88-3.25 7.85 1.15 5.76 3.25 7.85c2.09 2.09 4.88 3.25 7.85 3.25s5.76-1.15 7.85-3.25c4.32-4.33 4.32-11.37 0-15.7zm-1.06 14.64c-1.81 1.81-4.22 2.81-6.79 2.81s-4.98-1-6.79-2.81-2.81-4.22-2.81-6.79 1-4.98 2.81-6.79 4.22-2.81 6.79-2.81 4.98 1 6.79 2.81c3.74 3.74 3.74 9.83 0 13.58z"
              fill="#898989"
              opacity="1"
              data-original="#1576ed"
              className=""
            ></path>
            <path
              d="m57.54 58-9.24-9.25a3.966 3.966 0 0 0-3.25-1.13l-1.33-1.33c4.28-5.95 3.76-14.3-1.58-19.65-5.94-5.94-15.6-5.94-21.54 0s-5.94 15.6 0 21.54c2.97 2.97 6.87 4.45 10.77 4.45 3.12 0 6.24-.97 8.88-2.87l1.33 1.33c-.14 1.2.27 2.39 1.13 3.24l9.24 9.25a3.961 3.961 0 0 0 5.6 0c.75-.75 1.16-1.74 1.16-2.8A3.99 3.99 0 0 0 57.54 58zM21.65 47.13c-5.35-5.35-5.35-14.07 0-19.42 2.68-2.68 6.19-4.02 9.71-4.02s7.03 1.34 9.71 4.02c5.35 5.35 5.35 14.07 0 19.42s-14.06 5.35-19.42 0zm34.83 15.4c-.96.96-2.52.96-3.47 0l-9.24-9.24a2.45 2.45 0 0 1-.65-2.28.735.735 0 0 0-.2-.69l-1.47-1.47c.02-.02.03-.04.04-.06.22-.2.45-.38.66-.6.21-.21.39-.43.59-.65.02-.02.05-.03.06-.05l1.47 1.47c.18.18.44.26.69.2.83-.19 1.68.06 2.28.65l9.24 9.25a2.45 2.45 0 0 1 0 3.47z"
              fill="#898989"
              opacity="1"
              data-original="#1576ed"
              className=""
            ></path>
            <path
              d="M35.72 33.06a.754.754 0 0 0-1.06 0l-3.29 3.29-3.29-3.29c-.29-.29-.77-.29-1.06 0s-.29.77 0 1.06l3.29 3.3-3.29 3.29c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l3.29-3.29 3.29 3.29c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-3.29-3.29 3.29-3.3c.29-.29.29-.76 0-1.06zM23.92 7.2h18.95c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H23.92c-.41 0-.75.34-.75.75s.34.75.75.75zM42.88 9.67H23.91c-.41 0-.75.34-.75.75s.34.75.75.75h18.97c.41 0 .75-.34.75-.75s-.34-.75-.75-.75zM42.88 13.68h-9.96c-.41 0-.75.34-.75.75s.34.75.75.75h9.96c.41 0 .75-.34.75-.75s-.34-.75-.75-.75zM42.88 17.68h-9.96c-.41 0-.75.34-.75.75s.34.75.75.75h9.96c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z"
              fill="#898989"
              opacity="1"
              data-original="#1576ed"
              className=""
            ></path>
            <path
              d="M45.26 59.34H12.79v-2.48h28.49c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H8.8V12.98h9.48c.41 0 .75-.34.75-.75V2.75h28.72v43.4c0 .41.34.75.75.75s.75-.34.75-.75V6.73h2.48v43.03c0 .41.34.75.75.75s.75-.34.75-.75V5.98c0-.41-.34-.75-.75-.75h-3.23V2c0-.41-.34-.75-.75-.75H18.29c-.2 0-.39.08-.53.22L7.52 11.7a.75.75 0 0 0-.22.53V56.1c0 .41.34.75.75.75h3.23v3.23c0 .41.34.75.75.75h33.22c.41 0 .75-.34.75-.75s-.33-.74-.74-.74zM17.54 3.81v7.67H9.86z"
              fill="#898989"
              opacity="1"
              data-original="#1576ed"
              className=""
            ></path>
          </g>
        </g>
      </svg>
    </>
  );
}
